import React from 'react';
import moment from 'moment';
import ReactGA from 'react-ga';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import TagManager from 'react-gtm-module';
import { CookiesProvider } from 'react-cookie';
import { ThroughProvider } from 'react-through';
import { ConnectedRouter } from 'react-router-redux';
import createHistory from 'history/createBrowserHistory';
import { PersistGate } from 'redux-persist/lib/integration/react';

import { DEFAULT_LOCALE } from './constants/locale';
import { GA_TRACKING_NUMBER_PLEBICOM, GTM_CLIENT_ID } from './constants';

import App from './components/App';
import { configureStore } from './store';

import './scss/index.scss';

// set Google Analytics tracking number
// 15768000 = 6 mois en secondes
const trackers = [
    {
        trackingId: GA_TRACKING_NUMBER_PLEBICOM,
        gaOptions: { name: 'plebicom', cookieExpires: 15768000 }
    }
];
ReactGA.initialize(trackers);

const history = createHistory();
history.listen(location => {
    ReactGA.set({ page: location.pathname }, ['plebicom']);
    ReactGA.pageview(location.pathname, ['plebicom']);
});

// set Google Tag Manager
const tagManagerArgs = {
    gtmId: GTM_CLIENT_ID
};
TagManager.initialize(tagManagerArgs);

const { store, persistor } = configureStore(history);

// set Momentjs locale
moment.locale(DEFAULT_LOCALE);

render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <ConnectedRouter history={history}>
                <CookiesProvider>
                    <ThroughProvider>
                        <App />
                    </ThroughProvider>
                </CookiesProvider>
            </ConnectedRouter>
        </PersistGate>
    </Provider>,
    document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js